// src/components/RfiList.js
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import RfiForm from "./RfiForm";
import RfirevisionDial from "./RfiReviseDial";
import api from "../../api/axiosConfig";
import "./RfiList.css";
import { format } from "date-fns";
import { ProjectContext } from "../../App";
import { IoMdClose, IoMdDownload } from "react-icons/io";
import { AiOutlineLoading } from "react-icons/ai";
import { BiRevision } from "react-icons/bi";
import { useAuth } from "../Authentication/AuthContext";
import PizZip from "pizzip";
import EditIcon from "@mui/icons-material/Edit";
import { IoEyeOutline } from "react-icons/io5";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import { saveAs } from "file-saver";
import { motion } from "framer-motion";
import ExcelJS from "exceljs";
import { FaChevronDown } from "react-icons/fa";
import { useRolePermissions } from "../Settings/RoleContext";
import RfiFilter from "./RfiFilter";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardArrowLeft,
  MdKeyboardDoubleArrowRight,
  MdKeyboardArrowRight,
  MdOutlinePostAdd,
} from "react-icons/md";
import socket from "../../socket";
export default function RfiList() {
  const { hasPermission } = useRolePermissions();
  const { userDetails } = useAuth();
  const { dialBoxopen, isNavBarOpen } = useContext(ProjectContext);
  const [rfiNumber, setRfiNumber] = useState("");
  const [rfiQueryDial, setRfiQueryDial] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [rfiDocuments, setRfiDocuments] = useState([]);
  const now = new Date();
  const expiryDate = rfiDocuments[0]?.link_expires
    ? new Date(rfiDocuments[0].link_expires)
    : null;
  const isExpired = expiryDate ? expiryDate < now : false;
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const [newExpiry, setNewExpiry] = useState("");
  const [selectedLinkId, setSelectedLinkId] = useState(null);
  const [fileToDownload, setFileToDownload] = useState(null);
  const [fileToDelete, setFileToDelete] = useState([]);
  const [rfiRevisionDownload, setRfiRevisionDownload] = useState(false);
  const [activeRfiQueries, setActiveRfiQueries] = useState(null);
  const [rfiReviseQueryNumber, setRfiReviseQueryNumber] = useState("");
  const [rfiQueryToRevise, setRfiQueryToRevise] = useState("");
  const [rfiToRevise, setRfiToRevise] = useState("");
  const [rfiReviseDial, setRfiReviseDial] = useState(false);
  const { projectId } = useParams();
  const [rfis, setRfis] = useState([]);
  const [filter, setFilter] = useState({
    prepared_by: [],
    prepared_by_condition: "is",
    reviewed_by: [],
    reviewed_by_condition: "is",
    approved_by: [],
    approved_by_condition: "is",
    selected_phase: "",
    phase_condition: "is",
    selected_status: [],
    status_condition: "is",
  });
  const [isFilterActive, setFilterActive] = useState(false);
  const [rfisCount, setRfisCount] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rfiToDelete, setRfiToDelete] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showRevModal, setShowRevModal] = useState(false);
  const [availableRevs, setAvailableRevs] = useState([]);
  const checkFilterActive = (filter) => {
    return (
      filter.prepared_by.length > 0 ||
      filter.reviewed_by.length > 0 ||
      filter.approved_by.length > 0 ||
      filter.selected_phase.length > 0 ||
      filter.selected_status.length > 0
    );
  };
  const openExpiryModal = (folderItemId) => {
    setSelectedLinkId(folderItemId);
    setShowExpiryModal(true);
  };

  const closeExpiryModal = () => {
    setShowExpiryModal(false);
    setNewExpiry("");
  };
  useEffect(() => {
    setFilterActive(checkFilterActive(filter));
  }, [filter]);

  const handleOpenRevSelection = (tree) => {
    setAvailableRevs(extractRevisions(tree));
    setShowRevModal(true);
  };

  const [rfiPerPage, setRfiPerPage] = useState(() => {
    return Number(localStorage.getItem("rfiPerPage")) || 25;
  });
  const filteredRfis = rfis.filter((r) => {
    const search = searchTerm?.toLowerCase() || "";

    const matchesSearch =
      !r.queries ||
      r.queries.length === 0 ||
      r.queries.some(
        (q) =>
          q.query_text?.toLowerCase().includes(search) ||
          q.responses?.some((resp) =>
            resp.response?.toLowerCase().includes(search)
          )
      );

    const preparedNames = (r.requested_by_users || []).map((u) => u.name);

    const matchesPrepared =
      filter.prepared_by.length === 0
        ? true
        : filter.prepared_by_condition === "is"
        ? filter.prepared_by.some((name) => preparedNames.includes(name))
        : !filter.prepared_by.some((name) => preparedNames.includes(name));

    const reviewedNames = (r.reviewed_by_users || []).map((u) => u.name);

    const matchesReviewed =
      filter.reviewed_by.length === 0
        ? true
        : filter.reviewed_by_condition === "is"
        ? filter.reviewed_by.some((name) => reviewedNames.includes(name))
        : !filter.reviewed_by.some((name) => reviewedNames.includes(name));

    const approvedNames = (r.approved_by_users || []).map((u) => u.name);

    const matchesApproved =
      filter.approved_by.length === 0
        ? true
        : filter.approved_by_condition === "is"
        ? filter.approved_by.some((name) => approvedNames.includes(name))
        : !filter.approved_by.some((name) => approvedNames.includes(name));

    const phaseMatch =
      filter.selected_phase.length === 0
        ? true
        : filter.phase_condition === "is"
        ? filter.selected_phase.includes(r.phase_id)
        : !filter.selected_phase.includes(r.phase_id);

    const statusMatch =
      filter.selected_status.length === 0
        ? true
        : filter.status_condition === "is"
        ? filter.selected_status.includes(r.rfi_status)
        : !filter.selected_status.includes(r.rfi_status);

    return (
      matchesSearch &&
      matchesPrepared &&
      matchesReviewed &&
      matchesApproved &&
      phaseMatch &&
      statusMatch
    );
  });

  const openRfis = filteredRfis?.filter((r) => r.rfi_status === "Open")?.length;
  const closedRfis = filteredRfis?.filter(
    (r) => r.rfi_status === "Closed"
  )?.length;
  const outstandingRfis = filteredRfis?.filter(
    (r) => r.rfi_status === "Outstanding"
  )?.length;
  const [companyDetails, setCompanyDetails] = useState({
    name: "",
    companyregno: "",
    contactno: "",
    email: "",
    hourrate: "",
    website: "",
    logo: "",
    address: "",
    about: "",
    social: {
      facebook: "",
      twitter: "",
      linkedin: "",
    },
  });
  const [editingRfi, setEditingRfi] = useState(null);
  const [response, setResponse] = useState(false);
  const [orderedQueries, setOrderedQueries] = useState([]);

  // Build parent-child hierarchy
  const buildTree = (data) => {
    const map = {};
    data.forEach((item) => (map[item.id] = { ...item, children: [] }));
    const roots = [];
    data.forEach((item) => {
      if (item.parent_query_id) {
        map[item.parent_query_id]?.children.push(map[item.id]);
      } else {
        roots.push(map[item.id]);
      }
    });
    return roots;
  };

  const rfiTree = buildTree(orderedQueries);
  useEffect(() => {
    if (rfiRevisionDownload && orderedQueries.length > 0) {
      handleOpenRevSelection(rfiTree);
    }
  }, [rfiRevisionDownload, orderedQueries]);
  const highlightTerm = (text, searchTerm) => {
    if (!searchTerm) return text;

    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };
  const addFileLinks = (text, documents) => {
    const regex = / \[([^\]]+)\]/g;

    return text.replace(regex, (full, fileName) => {
      const doc = documents.find((d) => d.file_name === fileName);

      if (!doc) return full; // No match → leave as-is

      return `<a href="${doc.share_url}" target="_blank" 
              class="text-blue-600 no-underline bg-transparent">
              ${fileName}
            </a>`;
    });
  };

  const formatQueryText = (text, searchTerm, documents) => {
    let html = addFileLinks(text, documents);
    html = highlightTerm(html, searchTerm);
    return html;
  };

  const uniqueDocs = (docs) => {
    const map = new Map(docs.map((doc) => [doc.file_name, doc]));
    return Array.from(map.values());
  };

  // Recursive render
  const renderQuery = (q, level = 0) => (
    <div
      key={q.id}
      className={`relative border-l-2 mb-2 border border-solid bg-transparent ${
        level === 0 ? "bg-blue-50 border-none rounded-lg" : "border-none"
      }`}
    >
      <div
        className={`rounded-lg shadow-lg border mb-2 ${
          level === 0
            ? "bg-blue-100 border-blue-200"
            : "bg-gray-100 border-gray-200"
        } p-3`}
      >
        <div className="flex items-center justify-between bg-transparent">
          <h4 className="flex m-0 text-sm font-semibold text-gray-800 bg-transparent sm:text-base">
            {q.qNo && (
              <p className="m-0 font-semibold bg-transparent">
                {q.qNo.split(" ")[0]}{" "}
                <span className="text-xs font-normal text-black bg-transparent">
                  R{q.qNo.split(" ")[1].replace("R", "")}
                </span>
              </p>
            )}
            <div className="flex gap-4 bg-transparent">
              {/* <span
                className={`ml-4 text-[13px]  py-0.5 text-gray-500 bg-transparent font-normal`}
              >
                {q.raised_by_name}-{q.raised_by_emp_code}
              </span> */}
              <span
                className={`ml-4 text-[13px]  py-0.5 text-gray-500 bg-transparent font-normal`}
              >
                {q.created_at
                  ? format(new Date(q.created_at), "dd-MM-yyyy")
                  : ""}{" "}
              </span>

              {q.parent_query_id === null && (
                <span
                  className={`text-[13px] px-2 py-0.5 rounded-full ${
                    q.status === "Open"
                      ? "bg-yellow-100 text-yellow-700"
                      : "bg-green-100 text-green-700"
                  }`}
                >
                  {q.status}
                </span>
              )}
            </div>
          </h4>
          <div className="bg-transparent">
            {q.parent_query_id === null && q.status !== "Closed" && (
              <button
                onClick={() => {
                  setRfiReviseDial(true);
                  setRfiReviseQueryNumber(q.qNo);
                  setRfiQueryToRevise(q);
                  setRfiToRevise(activeRfiQueries.id);
                }}
                style={{
                  border: "none",
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  textAlign: "center",
                }}
              >
                <BiRevision className="bg-transparent" />
              </button>
            )}
          </div>
        </div>

        {/* Query Text */}
        <p
          className="mt-2 text-[15px] leading-snug text-gray-700  bg-transparent"
          dangerouslySetInnerHTML={{
            __html: formatQueryText(
              q.query_text,
              searchTerm,
              activeRfiQueries.documents
            ),
          }}
        ></p>

        {/* Responses */}
        {q.responses?.some(
          (res) => res.response?.trim() || res.responded_by?.trim()
        ) && (
          <div className="mt-3 space-y-2 border-t border-gray-200 rounded-lg">
            {q.responses
              .sort(
                (a, b) =>
                  new Date(b.responded_date) - new Date(a.responded_date)
              )
              .map(
                (res) =>
                  (res.response?.trim() || res.responded_by?.trim()) && (
                    <div
                      key={res.id}
                      className="p-2 bg-white border border-gray-100 rounded-md shadow-xs"
                    >
                      {/* <span className="font-medium text-[13px] text-[#F77F00]">
                        {res.entered_by_name}-{res.employeecode} :
                      </span> */}
                      {res.responded_by && (
                        <div className="flex gap-4 text-[13px] bg-transparent mt-2">
                          <span className="font-medium text-[#0057D9]">
                            {res.responded_by}
                          </span>{" "}
                          <span className=" text-[#E4572E]">
                            {res.responded_date
                              ? format(
                                  new Date(res.responded_date),
                                  "dd-MM-yyyy"
                                )
                              : ""}
                          </span>
                          <span className="text-[#0E9F6E]">
                            {res.discipline_name}
                          </span>
                          <span className="text-[#7B2CBF]">
                            {res.company_name}
                          </span>
                        </div>
                      )}
                      {res.response && (
                        <p
                          className="mt-2 text-[15px] leading-snug text-gray-700 whitespace-pre-line bg-transparent"
                          dangerouslySetInnerHTML={{
                            __html: formatQueryText(
                              res.response,
                              searchTerm,
                              rfis.documents
                            ),
                          }}
                        ></p>
                      )}
                    </div>
                  )
              )}
          </div>
        )}
      </div>

      {/* Revisions */}
      {q.children?.length > 0 && (
        <div className="mt-3 ml-6 bg-transparent">
          <p className="mb-1 text-xs font-semibold tracking-wide text-gray-500 uppercase bg-transparent">
            Revisions:
          </p>
          {q.children.map((child) => renderQuery(child, level + 1))}
        </div>
      )}
    </div>
  );

  function buildOrderedQueries(allQueries) {
    const orderedList = [];

    // Helper: recursively build child revisions
    function addRevisionsRecursively(parent, parentNo) {
      const children = allQueries
        .filter((q) => q.parent_query_id === parent.id)
        .sort((a, b) => a.id - b.id);

      children.forEach((child, index) => {
        // Each child gets a revision number based on position
        const childRev = index + 1;
        const qNo = `${parentNo} R${childRev}`;

        orderedList.push({ ...child, qNo });

        // Recursively handle deeper revisions
        addRevisionsRecursively(child, qNo);
      });
    }

    // Start with top-level parents
    const parents = allQueries
      .filter((q) => !q.parent_query_id)
      .sort((a, b) => a.id - b.id);

    parents.forEach((parent, parentIndex) => {
      const parentNo = `Q${parentIndex + 1}`;
      orderedList.push({ ...parent, qNo: `${parentNo} R0` });

      addRevisionsRecursively(parent, parentNo);
    });

    return orderedList;
  }

  useEffect(() => {
    if (!activeRfiQueries?.queries) return;
    const ordered = buildOrderedQueries(activeRfiQueries.queries);
    setOrderedQueries(ordered);
  }, [activeRfiQueries]);

  const fetchRfis = async () => {
    try {
      // const url =
      //   userDetails.role_name === "Administrator" ||
      //   userDetails.role_name === "Super Admin"
      //     ? `/api/rfi/${projectId}`
      //     : `/api/rfi/${projectId}/${userDetails.id}`;
      const res = await api.get(`/api/rfi/${projectId}`);
      const rfiResCount = await api.get(`/api/rfi/${projectId}`);
      setRfisCount(rfiResCount.data.length);
      setRfis(Array.isArray(res.data) ? res.data : []);
      const comapanyRes = await api.get("/api/company-settings");
      if (comapanyRes.data) {
        setCompanyDetails((prev) => ({
          ...prev,
          ...comapanyRes.data,
          social: {
            facebook: comapanyRes.data?.social?.facebook || "",
            twitter: comapanyRes.data?.social?.twitter || "",
            linkedin: comapanyRes.data?.social?.linkedin || "",
          },
        }));
      }
    } catch (err) {
      console.error("Error fetching RFIs:", err);
      setRfis([]);
    }
  };

  useEffect(() => {
    if (projectId) fetchRfis();
  }, [projectId]);
  useEffect(() => {
    socket.on("rfi added", (newRfi) => {
      if (Number(newRfi.project_id) === Number(projectId)) {
        setRfis((prev) => [...prev, newRfi]);
      }
      fetchRfis();
    });
    socket.on("rfi deleted", (rfiIds) => {
      setRfis((prev) => prev.filter((q) => !rfiIds.includes(q.id)));
    });

    socket.on("rfi updated", (updatedRfi) => {
      let rfi_status = "Open";
      let date;
      if (updatedRfi) {
        if (updatedRfi.queries.length > 0) {
          const allClosed = updatedRfi.queries.every(
            (q) => q.status === "Closed"
          );
          const allOpen = updatedRfi.queries.every((q) => q.status === "Open");

          if (allClosed) rfi_status = "Closed";
          else if (allOpen) rfi_status = "Open";
        } else rfi_status = "Open";
      }
      if (rfi_status === "Open") {
        // Keep link active for long time — valid ISO string
        date = "2099-12-31T23:59:59Z";
      } else if (rfi_status === "Closed") {
        // Expire immediately — must convert to ISO
        date = new Date().toISOString();
      }
      console.log("rfi date", date);

      const handleUrlStatus = async () => {
        try {
          await api.post("/api/rfi/set-status", {
            id: updatedRfi.id,
            rfi_status,
            date,
          });
        } catch (err) {
          console.log("error", err);
        }
      };

      if (rfi_status) {
        handleUrlStatus();
      }

      setRfis((prev) =>
        prev.map((rfi) =>
          Number(rfi.id) === Number(updatedRfi.id) ? updatedRfi : rfi
        )
      );
      setTimeout(() => {
        fetchRfis();
      }, 2000);
    });

    socket.on("query deleted", (queryIds) => {
      setRfis((prev) =>
        prev.map((rfi) => ({
          ...rfi,
          queries: Array.isArray(rfi.queries)
            ? rfi.queries.filter((q) => !queryIds.includes(q.id))
            : [],
        }))
      );
      setOrderedQueries((prev) => prev.filter((q) => !queryIds.includes(q.id)));
    });
    socket.on("query revised", (newQuery) => {
      setActiveRfiQueries((prev) => {
        if (!prev) return prev;

        // Replace only the previously latest revision for that parent
        const updatedQueries = prev.queries.map((q) =>
          q.parent_query_id === newQuery.parent_query_id && q.is_latest
            ? { ...q, is_latest: 0 }
            : q
        );

        return {
          ...prev,
          queries: [...updatedQueries, newQuery].sort((a, b) => a.id - b.id),
        };
      });
      fetchRfis();
    });

    return () => {
      socket.off("rfi added");
      socket.off("rfi deleted");
      socket.off("rfi updated");
      socket.off("query deleted");
      socket.off("query revised");
    };
  }, []);
  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/rfis`, { data: { rfiIds: rfiToDelete } });
      fetchRfis();
      setDeleteDialogOpen(false);
      setIsCheckboxChecked(false);
      setRfiToDelete([]);
    } catch (err) {
      console.error("Error deleting RFI:", err);
    }
  };

  const extractRevisions = (rfiTreeArray) => {
    const revs = new Set();

    const traverse = (q) => {
      // extract revision from q.qNo using regex
      if (q.qNo) {
        const match = q.qNo.match(/r\s*([0-9]+)/i);
        if (match) {
          revs.add(Number(match[1]));
        }
      }

      // continue traversing children
      q.children?.forEach(traverse);
    };

    // IMPORTANT: Loop through the array of root queries
    rfiTreeArray.forEach(traverse);

    return [...revs].sort((a, b) => a - b);
  };

  const collectQueriesByRev = (nodeArray, rev) => {
    let list = [];

    const traverse = (q) => {
      const match = q.qNo?.match(/r\s*([0-9]+)/i);
      const qRev = match ? Number(match[1]) : null;

      if (qRev === rev) {
        list.push(q);
      }

      q.children?.forEach(traverse);
    };

    nodeArray.forEach(traverse);

    return list;
  };

  const handleDownloadSelectedRevision = async (rev) => {
    setShowRevModal(false);
    setRfiRevisionDownload(false);
    const queries = collectQueriesByRev(rfiTree, rev);

    await handleDownloadRFIRevisedQuery(queries);
  };

  const handleDownloadRFIRevisedQuery = async (q) => {
    const rfi = activeRfiQueries;
    const disciplineInputs = (rfi.disciplines || []).map((d) =>
      d.name.trim().toLowerCase()
    );
    const categoryInputs = (rfi.categories || []).map((c) =>
      c.name.trim().toLowerCase()
    );

    const has = (list, name) =>
      list.some((n) => n.includes(name.toLowerCase()));

    const queriesArray = Array.isArray(q) ? q : [q];

    const combinedQueryText = queriesArray
      .map((item) => `${item.qNo}: ${item.query_text || ""}`)
      .join("\n\n");

    const combinedResponseText = queriesArray
      .map((item) => `${item.qNo}: ${item.response || ""}`)
      .join("\n\n");

    const latestRev = queriesArray[0]?.rev || "0";

    const data = {
      DA: has(disciplineInputs, "architectural") ? "☒" : "☐",
      DM: has(disciplineInputs, "mep") ? "☒" : "☐",
      DS: has(disciplineInputs, "steel structural") ? "☒" : "☐",
      DR: has(disciplineInputs, "roofing") ? "☒" : "☐",
      DC: has(disciplineInputs, "civil (concrete)") ? "☒" : "☐",
      DO: has(disciplineInputs, "others") ? "☒" : "☐",

      CD: has(categoryInputs, "design") ? "☒" : "☐",
      CDE: has(categoryInputs, "detailing") ? "☒" : "☐",
      CO: has(categoryInputs, "others") ? "☒" : "☐",

      other_discipline: has(disciplineInputs, "others")
        ? rfi.other_discipline || ""
        : "O – Others (Specify)",
      other_category: has(categoryInputs, "others")
        ? rfi.other_category || ""
        : "O – Others (Specify)",

      company_name: companyDetails.name || "",
      rfi_number: rfi.rfi_number || "",
      rev: latestRev,
      date: rfi.requested_date ? format(rfi.requested_date, "dd-MM-yyyy") : "",
      job_number: rfi.job_number,
      phase_number: rfi.phase_number,
      customer_name: rfi.customer_name || "",
      project_name: rfi.job_name || "",
      subject: rfi.subject || "",

      query: combinedQueryText,
      response: combinedResponseText,

      req_by_sort_code:
        rfi.requested_by_users.map((u) => u.sortcode).join(", ") || "",
      app_by_sort_code:
        rfi.approved_by_users.map((u) => u.sortcode).join(", ") || "",
      rev_by_sort_code:
        rfi.reviewed_by_users.map((u) => u.sortcode).join(", ") || "",
      responded_date: rfi.queries?.[0]?.responded_date
        ? format(rfi.queries?.[0]?.responded_date, "dd-MM-yyyy")
        : "",
    };

    const templateUrl = "/Rfi/RFI-sample.docx";
    const response = await fetch(templateUrl);
    const arrayBuffer = await response.arrayBuffer();

    const imageOpts = {
      centered: false,
      getImage: async (tagValue) => {
        const img = await fetch(tagValue);
        return await img.blob();
      },
      getSize: () => [120, 40],
    };

    const imageModule = new ImageModule(imageOpts);

    const zip = new PizZip(arrayBuffer);
    const doc = new Docxtemplater(zip, {
      modules: [imageModule],
      paragraphLoop: true,
      linebreaks: true,
    });

    doc.setData(data);

    try {
      doc.render();
    } catch (error) {
      console.error("Error rendering template:", error);
      return;
    }

    const blob = doc.getZip().generate({ type: "blob" });

    saveAs(
      blob,
      `${rfi.job_number}-${rfi.job_name}-${rfi.rfi_number}-REV-${latestRev}.docx`
    );
  };

  const exportToExcel = async (rfis) => {
    if (!rfis || rfis.length === 0) return alert("No RFIs to export");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("RFI LOG");

    const projectName =
      `${rfis[0]?.job_number} - ${rfis[0]?.job_name}` || "N/A";
    const totalColumns = 17;

    // ✅ Title
    const titleRow = worksheet.addRow(["RFI REGISTER"]);
    worksheet.mergeCells(1, 1, 1, totalColumns);
    titleRow.getCell(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    titleRow.font = { size: 16, bold: true, italic: true };
    titleRow.height = 25;

    // ✅ Project Name Row
    const projectRow = worksheet.addRow([
      `Project : ${projectName.toUpperCase()}`,
    ]);
    worksheet.mergeCells(2, 1, 2, totalColumns);
    projectRow.getCell(1).alignment = {
      horizontal: "left",
      vertical: "middle",
    };
    projectRow.font = { size: 12, bold: true, italic: true };
    projectRow.height = 30;

    // ✅ Headers
    const headers = [
      "RFI No",
      "Rev",
      "Phase Title",
      "Subject",
      "Client",
      "Discipline",
      "Category",
      "Prepared By",
      "Reviewed By",
      "Approved By",
      "Submitted On",
      "Due On",
      "Status",
      "Request for Information",
      "Response received",
      "Response",
      "Remarks",
    ];
    const headerRow = worksheet.addRow(headers.map((h) => h.toUpperCase()));
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "C0C0C0" },
      };
    });

    // ✅ Column widths
    worksheet.columns = [
      { key: "rfi_number", width: 10 },
      { key: "rev", width: 8 },
      { key: "phase_title", width: 20 },
      { key: "subject", width: 20 },
      { key: "customer_name", width: 30 },
      { key: "disciplines", width: 15 },
      { key: "categories", width: 15 },
      { key: "requested_by_user", width: 20 },
      { key: "reviewed_by_user", width: 20 },
      { key: "approved_by_user", width: 20 },
      { key: "requested_date", width: 15 },
      { key: "due_date", width: 15 },
      { key: "status", width: 12 },
      { key: "query_text", width: 40 },
      { key: "responded_date", width: 20 },
      { key: "response", width: 40 },
      { key: "description", width: 30 },
    ];

    // 🧠 Recursive builder for queries
    function buildOrderedQueries(allQueries) {
      const orderedList = [];
      function addChildren(parent, parentNo) {
        const children = allQueries
          .filter((q) => q.parent_query_id === parent.id)
          .sort((a, b) => a.id - b.id);
        children.forEach((child, index) => {
          const childNo = `${parentNo}.${index + 1}`;
          orderedList.push({ ...child, qNo: childNo });
          addChildren(child, childNo);
        });
      }
      const parents = allQueries
        .filter((q) => !q.parent_query_id)
        .sort((a, b) => a.id - b.id);
      parents.forEach((parent, index) => {
        const parentNo = `${index + 1}`;
        orderedList.push({ ...parent, qNo: parentNo });
        addChildren(parent, parentNo);
      });
      return orderedList;
    }

    // ✅ Add rows
    rfis.forEach((rfi) => {
      const ordered = rfi.queries ? buildOrderedQueries(rfi.queries) : [];

      if (ordered.length) {
        ordered.forEach((q) => {
          // group multiple responses into bullet list
          const responseDates = q.responses?.length
            ? q.responses
                .map((res) =>
                  res.responded_date
                    ? ` ${format(new Date(res.responded_date), "dd-MM-yyyy")}`
                    : ""
                )
                .filter(Boolean)
                .join("\n\n")
            : "";

          const responseTexts =
            Array.isArray(q.responses) && q.responses.length > 0
              ? q.responses
                  .map((res, index) =>
                    q.responses.length > 1
                      ? `${index + 1} - ${res.response || ""}`
                      : res.response || ""
                  )
                  .filter(Boolean)
                  .join("\n\n")
              : "";

          worksheet.addRow({
            rfi_number: `${rfi.rfi_number}-${q.qNo}`,
            rev: q.rev ?? "0",
            phase_title: rfi.phase_title,
            subject: rfi.subject,
            customer_name: rfi.customer_name || "",
            disciplines: rfi.disciplines
              ?.map((d) =>
                d.name === "Others (Specify)" ? rfi.other_discipline : d.name
              )
              .join(", "),
            categories: rfi.categories
              ?.map((d) =>
                d.name === "Others (Specify)" ? rfi.other_category : d.name
              )
              .join(", "),
            requested_by_user: Array.isArray(rfi.requested_by_users)
              ? rfi.requested_by_users.map((u) => u.sortcode).join(", ")
              : "",
            reviewed_by_user: Array.isArray(rfi.reviewed_by_users)
              ? rfi.reviewed_by_users.map((u) => u.sortcode).join(", ")
              : "",
            approved_by_user: Array.isArray(rfi.approved_by_users)
              ? rfi.approved_by_users.map((u) => u.sortcode).join(", ")
              : "",
            requested_date: format(rfi.requested_date, "dd-MM-yyyy"),
            due_date: format(rfi.due_date, "dd-MM-yyyy"),
            status: q.status || rfi.status,
            query_text: q.query_text || "",
            responded_date: responseDates,
            response: responseTexts,
            description: rfi.description || "",
          });
        });
      } else {
        worksheet.addRow({
          rfi_number: rfi.rfi_number,
          rev: rfi.rev ?? 0,
          phase_title: rfi.phase_title,
          subject: rfi.subject,
          customer_name: rfi.customer_name || "",
          disciplines: rfi.disciplines.map((d) => d.name).join(", "),
          categories: rfi.categories.map((d) => d.name).join(", "),
          requested_by_user: Array.isArray(rfi.requested_by_users)
            ? rfi.requested_by_users.map((u) => u.sortcode).join(", ")
            : "",
          reviewed_by_user: Array.isArray(rfi.reviewed_by_users)
            ? rfi.reviewed_by_users.map((u) => u.sortcode).join(", ")
            : "",
          approved_by_user: Array.isArray(rfi.approved_by_users)
            ? rfi.approved_by_users.map((u) => u.sortcode).join(", ")
            : "",
          requested_date: format(rfi.requested_date, "dd-MM-yyyy"),
          due_date: format(rfi.due_date, "dd-MM-yyyy"),
          status: rfi.status,
          query_text: "",
          responded_date: "",
          response: "",
          description: rfi.description || "",
        });
      }
    });

    // ✅ Apply border, alignment & fill
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 3) {
        const status = (row.getCell(13).value || "")
          .toString()
          .trim()
          .toLowerCase();

        const fillColor = status === "closed" ? "EBF1DE" : "FFFFFF";

        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          // Force empty cells to be real Excel cells
          if (cell.value === null || cell.value === undefined) {
            cell.value = "";
          }

          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            horizontal: [14, 16].includes(colNumber) ? "left" : "center",
            vertical: "middle",
            wrapText: true,
          };

          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: fillColor },
          };
        });
      }
    });

    // ✅ Save Excel
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `RFI-Register-${projectName}.xlsx`);
  };

  const handleSetDeleteId = (e, id) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setRfiToDelete((prev) => [...prev, id]);
    } else {
      setRfiToDelete((prev) => prev.filter((rfiId) => rfiId !== id));
    }
  };

  useEffect(() => {
    if (!fileToDownload) return;

    const download = async () => {
      try {
        const res = await api.get(
          `/api/sharepoint/download/${fileToDownload}`,
          {
            responseType: "blob",
          }
        );

        const disposition = res.headers["content-disposition"];

        let fileName = "downloaded-file";

        if (disposition && disposition.includes("filename=")) {
          fileName = disposition.split("filename=")[1].replace(/"/g, "");
        }

        const blob = new Blob([res.data], { type: res.data.type });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // ⬅ Use backend file name
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (err) {
        console.error("Download error:", err);
      } finally {
        setFileToDownload(null);
      }
    };
    if (fileToDownload) {
      download();
    }
  }, [fileToDownload]);

  const totalPages = Math.ceil(filteredRfis.length / rfiPerPage);
  const indexOfLastRfi = currentPage * rfiPerPage;
  const indexOfFirstRfi = indexOfLastRfi - rfiPerPage;
  const currentRfis = filteredRfis.slice(indexOfFirstRfi, indexOfLastRfi);
  const calculatePaginationCount = (rfiPerPage, currentPage) => {
    const start = (currentPage - 1) * rfiPerPage + 1;
    const end = start + rfiPerPage - 1;
    return `${start}-${end}`;
  };
  const paginationCount = calculatePaginationCount(rfiPerPage, currentPage);
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };
  const handleFirstPage = () => {
    if (currentPage > 1) setCurrentPage(1);
  };
  const handleLastPage = () => {
    if (currentPage < totalPages) setCurrentPage(totalPages);
  };
  const handleClearFilters = () => {
    setFilter({
      prepared_by: [],
      prepared_by_condition: "is",
      reviewed_by: [],
      reviewed_by_condition: "is",
      approved_by: [],
      approved_by_condition: "is",
      selected_phase: "",
      phase_condition: "is",
      selected_status: [],
      status_condition: "is",
    });
    setFilterActive(false);
  };

  const handleDeleteFiles = async (fileToDelete) => {
    try {
      const delRes = api.post("/api/sharepoint/files/delete-multiple", {
        itemIds: fileToDelete,
      });
      fetchRfis();
      setFileToDelete([]);
      setShowDocuments(false);
      setRfiDocuments([]);
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleChangeExpiry = (folderItemId) => {
    openExpiryModal(folderItemId);
    setShowDocuments(false);
  };

  const handleSubmitExpiry = async () => {
    if (!newExpiry) {
      alert("Please select date");
      return;
    }

    const isoDate = new Date(newExpiry).toISOString();

    const res = await api.post("/api/rfi/update-expiry", {
      folderItemId: selectedLinkId,
      expiryDateTime: isoDate,
    });

    const data = res.data;
    if (data.success) {
      fetchRfis();
      closeExpiryModal();
    } else {
      alert("Failed to update expiry");
    }
  };

  return (
    !dialBoxopen && (
      <div className={isNavBarOpen ? "main-container" : "main-container-close"}>
        <div
          className={
            `relative left-px bg-transparent flex flex-row justify-between transition-all duration-300 overflow-hidden ` +
            (isNavBarOpen ? "w-[94vw]" : "w-[98vw]")
          }
        >
          <input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="timesheet-input"
            placeholder="Enter keyword to search"
          />
          <div
            className={isNavBarOpen ? "rfi-add-filter" : "rfi-add-filter-close"}
          >
            {rfiToDelete.length > 0 && (
              <button
                className="delete-rfi-button"
                onClick={() => setDeleteDialogOpen(true)}
              >
                Delete
              </button>
            )}
            {isFilterActive && (
              <button
                className=" h-[28px] w-[110px] rounded-[3px] border border-red-500 bg-white text-red-500 cursor-pointer font-semibold text-[13px]"
                onClick={handleClearFilters}
                title="Clear Filters"
              >
                Clear Filters
              </button>
            )}
            <button
              className="export-rfi-btn"
              onClick={() => exportToExcel(filteredRfis)}
            >
              Export to excel
            </button>
            <RfiForm
              userDetails={userDetails}
              projectId={projectId}
              rfi={editingRfi}
              setEditingRfi={setEditingRfi}
              onSuccess={fetchRfis}
              rfiCount={rfisCount}
              rfiNumber={rfiNumber}
              response={response}
              setResponse={() => setResponse(false)}
            />
            <RfiFilter
              projectId={projectId}
              setFilter={setFilter}
              isFilterActive={isFilterActive}
            />
          </div>
        </div>
        <div
          className={`p-[1rem] pl-0 pt-0 h-[74vh] overflow-y-auto relative top-3 no-scrollbar  ${
            isNavBarOpen ? "w-[93.5vw]" : "w-[97vw]"
          }`}
        >
          <table
            className={`relative ${
              isNavBarOpen ? "phase-table" : "phase-table-close"
            }`}
          >
            <thead>
              <tr>
                {hasPermission("rfi", "delete") && (
                  <th style={{ width: "2px", textAlign: "center" }}>
                    <FaChevronDown />
                  </th>
                )}
                <th style={{ width: "2rem", textWrap: "nowrap" }}>RFI No.</th>
                <th style={{ width: "5rem", textWrap: "nowrap" }}>Phase</th>
                <th style={{ width: "2rem", textWrap: "nowrap" }}>Subject</th>
                <th
                  style={{ width: "8rem", textWrap: "wrap", overflow: "auto" }}
                >
                  Remarks
                </th>
                <th style={{ width: "5rem", textWrap: "nowrap" }}>
                  Discipline
                </th>
                <th style={{ width: "5rem", textWrap: "nowrap" }}>Category</th>
                <th style={{ width: "5rem", textWrap: "nowrap" }}>
                  Prepared by
                </th>
                <th style={{ width: "5rem", textWrap: "nowrap" }}>
                  Reviewed by
                </th>
                <th style={{ width: "5rem", textWrap: "nowrap" }}>
                  Approved by
                </th>
                <th style={{ width: "5rem" }}>Submitted on</th>
                <th style={{ width: "5rem" }}>Due on</th>
                <th style={{ width: "5rem" }}>Cost impact</th>
                <th style={{ width: "5rem" }}>Schedule impact</th>
                <th style={{ width: "5rem" }}>Priority</th>
                <th style={{ width: "1rem" }}>Status</th>
                <th style={{ width: "1rem" }}>Documents</th>
                <th style={{ width: "1rem" }}>Response</th>
                <th style={{ width: "4rem" }}>Download</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {currentRfis.map((rfi) => (
                <tr key={rfi.id}>
                  {hasPermission("rfi", "delete") && (
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        type="checkbox"
                        name={rfi.rfi_number}
                        checked={rfiToDelete.includes(rfi.id)}
                        onChange={(e) => handleSetDeleteId(e, rfi.id)}
                      />
                    </td>
                  )}
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        whiteSpace: "nowrap",
                        alignItems: "center",
                        height: "27px",
                        minwidth: "140px",
                        maxwidth: "100%",
                      }}
                    >
                      <p
                        onClick={() => {
                          setActiveRfiQueries(rfi);
                          setRfiNumber(rfi.rfi_number);
                          setRfiQueryDial(true);
                        }}
                        className="cursor-pointer hover:text-purple-700 hover:font-bold"
                      >
                        {rfi.rfi_number}
                      </p>
                      {hasPermission("rfi", "update") && (
                        <button
                          style={{
                            border: "none",
                            color: "blue",
                            cursor: "pointer",
                            backgroundColor: "transparent",
                          }}
                          className="edit-icon-wrapper"
                          onClick={() => {
                            setEditingRfi(rfi);
                            setRfiNumber(rfi.rfi_number);
                            setResponse(false);
                          }}
                        >
                          <EditIcon
                            style={{ backgroundColor: "transparent" }}
                          />
                        </button>
                      )}
                    </div>
                  </td>
                  <td>{rfi.phase_title}</td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={rfi?.subject}
                  >
                    {rfi?.subject?.length > 30
                      ? rfi.subject.slice(0, 20) + "..."
                      : rfi?.subject}
                  </td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={rfi?.description}
                  >
                    {rfi?.description?.length > 30
                      ? rfi.description.slice(0, 20) + "..."
                      : rfi?.description}
                  </td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={
                      rfi.disciplines && rfi.disciplines.length > 0
                        ? rfi.disciplines
                            .map((d) =>
                              d.id === 8
                                ? rfi.other_discipline || "Others"
                                : d.name
                            )
                            .join(", ")
                        : "-"
                    }
                  >
                    {(() => {
                      const text =
                        rfi.disciplines && rfi.disciplines.length > 0
                          ? rfi.disciplines
                              .map((d) =>
                                d.id === 8
                                  ? rfi.other_discipline || "Others"
                                  : d.name
                              )
                              .join(", ")
                          : "-";

                      return text.length > 30
                        ? text.slice(0, 20) + "..."
                        : text;
                    })()}
                  </td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={
                      rfi.categories && rfi.categories.length > 0
                        ? rfi.categories
                            .map((c) =>
                              c.id === 3
                                ? rfi.other_category || "Other"
                                : c.name
                            )
                            .join(", ")
                        : "-"
                    }
                  >
                    {(() => {
                      const text =
                        rfi.categories && rfi.categories.length > 0
                          ? rfi.categories
                              .map((c) =>
                                c.id === 3
                                  ? rfi.other_category || "Other"
                                  : c.name
                              )
                              .join(", ")
                          : "-";

                      return text.length > 30
                        ? text.slice(0, 20) + "..."
                        : text;
                    })()}
                  </td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={
                      Array.isArray(rfi.requested_by_users)
                        ? rfi.requested_by_users.map((u) => u.name).join(", ")
                        : "—"
                    }
                  >
                    {(() => {
                      const text = Array.isArray(rfi.requested_by_users)
                        ? rfi.requested_by_users.map((u) => u.name).join(", ")
                        : "—";

                      return text.length > 30
                        ? text.slice(0, 20) + "..."
                        : text;
                    })()}
                  </td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={
                      Array.isArray(rfi.reviewed_by_users)
                        ? rfi.reviewed_by_users.map((u) => u.name).join(", ")
                        : "—"
                    }
                  >
                    {(() => {
                      const text = Array.isArray(rfi.reviewed_by_users)
                        ? rfi.reviewed_by_users.map((u) => u.name).join(", ")
                        : "—";

                      return text.length > 30
                        ? text.slice(0, 20) + "..."
                        : text;
                    })()}
                  </td>
                  <td
                    className="cursor-pointer min-w-10 max-w-72"
                    title={
                      Array.isArray(rfi.approved_by_users)
                        ? rfi.approved_by_users.map((u) => u.name).join(", ")
                        : "—"
                    }
                  >
                    {(() => {
                      const text = Array.isArray(rfi.approved_by_users)
                        ? rfi.approved_by_users.map((u) => u.name).join(", ")
                        : "—";

                      return text.length > 30
                        ? text.slice(0, 20) + "..."
                        : text;
                    })()}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {format(rfi.requested_date, "dd-MM-yyyy")}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {rfi.due_date ? format(rfi.due_date, "dd-MM-yyyy") : ""}
                  </td>
                  <td className="text-center capitalize">{rfi.cost_impact}</td>
                  <td className="text-center capitalize">
                    {rfi.schedule_impact}
                  </td>
                  <td className="text-center capitalize">{rfi.priority}</td>
                  <td className="w-[5rem]">
                    <div className="flex flex-col">
                      <div className="flex justify-between mb-1 text-xs text-gray-600">
                        <span>{rfi.rfi_status}</span>
                        <span>
                          {
                            rfi.queries.filter(
                              (q) => q.status === "Closed" && q.rev === 0
                            ).length
                          }
                          /{rfi.queries.filter((r) => r.rev === 0).length}
                        </span>
                      </div>
                      <div className="w-full h-2 overflow-hidden bg-gray-300 rounded-full">
                        <div
                          className={`h-full rounded-full ${
                            rfi.rfi_status === "Closed"
                              ? "bg-green-500"
                              : rfi.rfi_status === "Outstanding"
                              ? "bg-yellow-500"
                              : "bg-blue-500"
                          }`}
                          style={{
                            width: `${
                              (rfi.queries.filter(
                                (q) => q.status === "Closed" && q.rev === 0
                              ).length /
                                rfi.queries.filter((r) => r.rev === 0).length) *
                              100
                            }%`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td
                    style={{ textAlign: "center", cursor: "pointer" }}
                    onClick={() => {
                      if (rfi.documents?.length > 0) {
                        setRfiDocuments(rfi.documents);
                        setShowDocuments(true);
                      }
                    }}
                  >
                    {rfi.documents && uniqueDocs(rfi.documents).length}
                  </td>
                  <td className="flex justify-center">
                    <button
                      className="border-none"
                      onClick={() => {
                        setEditingRfi(rfi);
                        setRfiNumber(rfi.rfi_number);
                        setResponse(true);
                      }}
                    >
                      <MdOutlinePostAdd className="text-xl text-blue-500 cursor-pointer" />
                    </button>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {" "}
                    <button
                      style={{
                        border: "none",
                        color: "#6200ee",
                        cursor: "pointer",
                        backgroundColor: "transparent",
                      }}
                      onClick={async () => {
                        setActiveRfiQueries(rfi);
                        setRfiQueryDial(false);
                        setRfiRevisionDownload(true);
                      }}
                    >
                      <IoMdDownload
                        style={{ backgroundColor: "transparent" }}
                      />
                    </button>
                  </td>{" "}
                </tr>
              ))}
            </tbody>
          </table>
          <div
            className={`fixed bottom-0 flex items-center justify-between h-10 px-[1rem] text-sm bg-transparent  border-t border-[0.5px] border-solid border-[#ddd] border-x-0 ${
              isNavBarOpen ? "w-[95vw] left-[4.5rem]" : "w-[98.7vw] left-[0rem]"
            }`}
          >
            <div className="flex justify-between w-[18rem]">
              <p>
                Open :{" "}
                <span className="ml-1 font-bold text-gray-500">{openRfis}</span>
              </p>
              <p>
                Outstanding :{" "}
                <span className="ml-1 font-bold text-yellow-500">
                  {outstandingRfis}
                </span>
              </p>
              <p>
                Closed :{" "}
                <span className="ml-1 font-bold text-green-500">
                  {closedRfis}
                </span>
              </p>
            </div>
            <div className="flex items-center bg-transparent">
              <h3 className="m-0 text-sm font-normal">
                Total : {filteredRfis.length}
              </h3>
              <select
                className="border border-white/0 p-1 rounded text-center font-lato text-sm cursor-pointer outline-none bg-transparent ml-1.5"
                value={rfiPerPage}
                onChange={(e) => {
                  setRfiPerPage(Number(e.target.value));
                }}
              >
                <option value="25">25 Records Per Page</option>
                <option value="50">50 Records Per Page</option>
                <option value="75">75 Records Per Page</option>
                <option value="100">100 Records Per Page</option>
              </select>
              <button
                onClick={handleFirstPage}
                disabled={currentPage === 1}
                className="border-none mt-[0px] cursor-pointer bg-transparent"
              >
                <MdKeyboardDoubleArrowLeft title="First Page" />
              </button>
              <button
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                className="border-none mt-[0px] cursor-pointer bg-transparent"
              >
                {/* */}
                <MdKeyboardArrowLeft title="Previous Page" />
              </button>
              <span>{paginationCount}</span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className="border-none mt-[0px] cursor-pointer bg-transparent"
              >
                <MdKeyboardArrowRight title="Next Page" />
              </button>
              <button
                onClick={handleLastPage}
                disabled={currentPage === totalPages}
                className="border-none mt-[0px] cursor-pointer bg-transparent"
              >
                <MdKeyboardDoubleArrowRight title="Last Page" />
              </button>
            </div>
          </div>
        </div>
        {showDocuments && (
          <div className={`rfi-rev-overlay ${dialBoxopen ? "open" : "close"}`}>
            <div className="flex flex-col items-start gap-2 p-4 h-[35%] rounded-lg">
              <div className="flex items-center justify-end w-full gap-3">
                {/* <div>
                  {hasPermission("rfi", "update") && (
                    <button
                      onClick={() =>
                        handleChangeExpiry(rfiDocuments[0].rfi_folder_id)
                      }
                      className="px-[10px] w-[9rem] py-[6px] text-nowrap border-none text-white rounded-[3px] bg-blue-600 cursor-pointer font-lato text-[13px]"
                    >
                      Change Expiry Date
                    </button>
                  )}
                  {isExpired ? (
                    !hasPermission("rfi", "update") && (
                      <p className="text-xs text-gray-500 text-nowrap">
                        Link expired. Ask DC to extend it.
                      </p>
                    )
                  ) : (
                    <p className="text-sm text-gray-500 text-nowrap">
                      Link Expires on :{" "}
                      {expiryDate
                        ? format(expiryDate, "dd-MM-yyyy HH:mm")
                        : "-"}
                    </p>
                  )}
                </div> */}
                <div className="w-[70px] flex">
                  {fileToDelete.length > 0 ? (
                    <button
                      onClick={() => handleDeleteFiles(fileToDelete)}
                      className="px-[10px] py-[6px] text-center border-none text-white rounded-[3px] bg-red-600 cursor-pointer font-lato text-[13px]"
                    >
                      Delete
                    </button>
                  ) : (
                    <div className="h-[27px]" />
                  )}
                </div>
                <IoMdClose
                  onClick={() => {
                    setShowDocuments(false);
                    setRfiDocuments([]);
                  }}
                  className="relative items-end justify-end w-5 h-5 bg-transparent cursor-pointer right-1"
                />
              </div>
              <div className="overflow-y-auto h-[90%] p-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                <ul className="m-0 bg-transparent">
                  {uniqueDocs(rfiDocuments).map((r) => (
                    <div>
                      <li
                        key={r.id}
                        className="flex items-center justify-between gap-4 p-3 mb-2 border rounded-lg shadow-lg bg-gray-50"
                      >
                        {/* Left: File name + date */}
                        <div className="flex flex-row items-start justify-start gap-3 mr-10 bg-transparent">
                          {" "}
                          <input
                            type="checkbox"
                            className="cursor-pointer"
                            checked={fileToDelete.includes(r.item_id)}
                            onChange={(e) => {
                              setFileToDelete((prev) =>
                                e.target.checked
                                  ? [...prev, r.item_id]
                                  : prev.filter((id) => id !== r.item_id)
                              );
                            }}
                          />
                          <div className="bg-transparent">
                            <p className="font-semibold text-[14px] mt-0 bg-transparent truncate max-w-[200px]">
                              {r.file_name}
                            </p>
                            <p className="text-sm text-gray-500 bg-transparent">
                              {r.uploaded_at &&
                                format(r.uploaded_at, "dd-MM-yyyy")}
                            </p>
                          </div>
                        </div>

                        {/* Right: Actions */}
                        <div className="flex gap-3 bg-transparent">
                          <a
                            href={r.share_url}
                            target="_blank"
                            className="flex items-center justify-center cursor-pointer px-2 py-2 text-[#6200ee] bg-transparent rounded-full transition-colors duration-300 ease-out hover:bg-[#6200ee]/10 hover:text-[#4500b5]"
                          >
                            <IoEyeOutline className="bg-transparent" />
                          </a>
                          {fileToDownload !== r.item_id && !isExpired && (
                            <a
                              onClick={() => setFileToDownload(r.item_id)}
                              className="px-2 py-2 flex items-center justify-center cursor-pointer text-[#6200ee] bg-transparent rounded-full transition-colors duration-300 ease-out  hover:bg-[#6200ee]/10 hover:text-[#4500b5]"
                            >
                              <IoMdDownload className="bg-transparent" />
                            </a>
                          )}
                          {fileToDownload === r.item_id && (
                            <a className="px-2 py-2 text-white flex items-center justify-center bg-[#6200ee] rounded-full hover:bg-[#6200ee]">
                              <AiOutlineLoading
                                className={`text-md bg-transparent ${
                                  fileToDownload === r.item_id
                                    ? "animate-spin text-xl"
                                    : ""
                                }`}
                              />
                            </a>
                          )}
                        </div>
                      </li>
                    </div>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
        {showExpiryModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-lg p-6 w-[350px] shadow-lg">
              <h2 className="mb-4 text-lg font-semibold text-center">
                Update Expiry Date
              </h2>

              <label className="block mb-2 text-sm font-medium">
                Select New Date
              </label>
              <input
                type="datetime-local"
                value={newExpiry}
                onChange={(e) => setNewExpiry(e.target.value)}
                className="w-full px-3 py-2 mb-4 border rounded-md focus:ring focus:ring-blue-300"
              />

              <div className="flex justify-between">
                <button
                  onClick={closeExpiryModal}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>

                <button
                  onClick={handleSubmitExpiry}
                  className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
        {rfiQueryDial && !rfiReviseDial && activeRfiQueries?.queries && (
          <div className="query-modal">
            <div className="query-modal-content">
              <div className="query-modal-header">
                <h3 className="rfi-query-tree">RFI Query Tree</h3>
                <h3 className="rfi-query-tree">{rfiNumber}</h3>{" "}
                <div className="rfi-queries-del-close-con">
                  <button
                    style={{
                      border: "none",
                      color: "#6200ee",
                      cursor: "pointer",
                      backgroundColor: "transparent",
                    }}
                    onClick={() => handleOpenRevSelection(rfiTree)}
                  >
                    <IoMdDownload className="bg-transparent" />
                  </button>
                  <button
                    className="close-modal"
                    onClick={() => {
                      setActiveRfiQueries(null);
                      setRfiNumber("");
                    }}
                  >
                    <IoMdClose />
                  </button>{" "}
                </div>
              </div>

              <div className="query-table-wrapper">
                <div className="p-0 pr-4 bg-white border border-gray-200 rounded-xl">
                  {rfiTree.map((root) => renderQuery(root))}
                </div>
                <style>{`
        .no-select, .no-select * {
          user-select: none !important;
        }
        .resize-handle {
          user-select: none;
        }
      `}</style>
              </div>
            </div>
          </div>
        )}
        {showRevModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[9999]">
            <div className="bg-white  rounded-lg shadow-lg w-[370px] text-center animate-fadeIn">
              <h2 className="text-[15px] font-semibold m-0 bg-[#f5f5f5] p-2 pl-[1rem] h-[30px] items-center rounded-t-lg rounded-r-lg top-0 left-0 z-2 flex flex-row justify-between">
                Select Revision
              </h2>

              <div className="grid grid-cols-3 mx-[1rem] mt-[1rem] gap-3">
                {availableRevs.map((r) => (
                  <button
                    key={r}
                    className="p-2 border rounded cursor-pointer hover:bg-gray-100"
                    onClick={() => handleDownloadSelectedRevision(r)}
                  >
                    R{r}
                  </button>
                ))}
              </div>

              <button
                className="flex w-[91%] text-center justify-center p-2 m-4 text-white bg-red-600 border-none rounded cursor-pointer "
                onClick={() => {
                  setOrderedQueries([]);
                  setRfiRevisionDownload(false);
                  setActiveRfiQueries(null);
                  setShowRevModal(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        {deleteDialogOpen && (
          <div className="delete-phase-dial">
            <div className="delete-dial">
              <div className="delete-header">
                <h3
                  style={{
                    backgroundColor: "transparent",
                    marginLeft: "15px",
                    fontSize: "15px",
                  }}
                >
                  Delete RFI
                </h3>
              </div>
              <div style={{ backgroundColor: "white" }}>
                <p style={{ backgroundColor: "white" }}>
                  Are you sure you want to delete this Rfi? This action cannot
                  be undone.
                </p>
                <input
                  style={{ cursor: "pointer" }}
                  type="checkbox"
                  id="delete-phase"
                  checked={isCheckboxChecked}
                  onChange={() => setIsCheckboxChecked((prev) => !prev)}
                />
                <label
                  htmlFor="delete-phase"
                  style={{ backgroundColor: "white", cursor: "pointer" }}
                >
                  I understand this action cannot be undone.
                </label>
              </div>
              <div className="delete-dial-btn-con">
                <motion.button
                  whileTap={{ scale: 0.9 }}
                  onClick={() => handleDelete(rfiToDelete)}
                  color="secondary"
                  variant="contained"
                  disabled={!isCheckboxChecked}
                  className="add-btn"
                  style={{
                    backgroundColor: isCheckboxChecked ? "red" : "gray",
                  }}
                >
                  Delete
                </motion.button>

                <motion.button
                  whileTap={{ scale: 0.9 }}
                  onClick={() => {
                    setDeleteDialogOpen(false);
                    setIsCheckboxChecked(false);
                    setRfiToDelete([]);
                  }}
                  className="cancel-btn"
                >
                  Cancel
                </motion.button>
              </div>
            </div>
          </div>
        )}

        {rfiReviseDial && (
          <RfirevisionDial
            rfiNumber={rfiNumber}
            rfiReviseQueryNumber={rfiReviseQueryNumber}
            rfiQueryToRevise={rfiQueryToRevise}
            rfiToRevise={rfiToRevise}
            setRfiReviseDial={setRfiReviseDial}
            userDetails={userDetails}
          />
        )}
      </div>
    )
  );
}
